export type SelectOption = {
  value: string;
  label: string;
};

export const EMPLOYMENT_TYPE_OPTIONS: SelectOption[] = [
  { value: 'Celetista', label: 'Celetista' },
  { value: 'PrestadorServico', label: 'Prestador de serviço' },
  { value: 'Autonomo', label: 'Autônomo' },
  { value: 'Estagiario', label: 'Estagiário' },
  { value: 'Aprendiz', label: 'Aprendiz' },
  { value: 'Socio', label: 'Sócio' },
  { value: 'Temporario', label: 'Temporário' },
  { value: 'Intermitente', label: 'Intermitente' },
];

export const JOB_LEVEL_OPTIONS: SelectOption[] = [
  { value: 'Aprendiz', label: 'Aprendiz' },
  { value: 'Estagiario', label: 'Estagiário' },
  { value: 'Junior', label: 'Júnior' },
  { value: 'Pleno', label: 'Pleno' },
  { value: 'Senior', label: 'Sênior' },
  { value: 'Especialista', label: 'Especialista' },
  { value: 'Gerente', label: 'Gerente' },
  { value: 'Diretor', label: 'Diretor' },
  { value: 'Conselheiro', label: 'Conselheiro' },
];

export const MARITAL_STATUS_OPTIONS: SelectOption[] = [
  { value: 'Solteiro', label: 'Solteiro(a)' },
  { value: 'Casado', label: 'Casado(a)' },
  { value: 'Divorciado', label: 'Divorciado(a)' },
  { value: 'Viuvo', label: 'Viúvo(a)' },
  { value: 'UniaoEstavel', label: 'União estável' },
  { value: 'Separado', label: 'Separado(a)' },
];

export const RACE_ETHNICITY_OPTIONS: SelectOption[] = [
  { value: 'Amarelo', label: 'Amarelo' },
  { value: 'Branco', label: 'Branco' },
  { value: 'Indigena', label: 'Indígena' },
  { value: 'Pardo', label: 'Pardo' },
  { value: 'Preto', label: 'Preto' },
];

export const GENDER_OPTIONS: SelectOption[] = [
  { value: 'Feminino', label: 'Feminino' },
  { value: 'Masculino', label: 'Masculino' },
  { value: 'NaoBinario', label: 'Não-binário' },
  { value: 'PrefiroNaoDizer', label: 'Prefiro não dizer' },
  { value: 'Outro', label: 'Outro' },
];

export const SEXUAL_ORIENTATION_OPTIONS: SelectOption[] = [
  { value: 'Assexual', label: 'Assexual' },
  { value: 'Bissexual', label: 'Bissexual' },
  { value: 'Heterossexual', label: 'Heterossexual' },
  { value: 'Homossexual', label: 'Homossexual' },
  { value: 'Pansexual', label: 'Pansexual' },
  { value: 'PrefiroNaoResponder', label: 'Prefiro não responder' },
];

export const DISABILITY_TYPE_OPTIONS: SelectOption[] = [
  { value: 'Fisica', label: 'Física' },
  { value: 'Visual', label: 'Visual' },
  { value: 'Auditiva', label: 'Auditiva' },
  { value: 'Intelectual', label: 'Intelectual' },
  { value: 'MentalPsicossocial', label: 'Mental / Psicossocial' },
  { value: 'EspectroAutista', label: 'Espectro Autista (TEA)' },
  { value: 'Outro', label: 'Outro' },
];

export const EDUCATION_TYPE_OPTIONS: SelectOption[] = [
  { value: 'EnsinoMedio', label: 'Ensino médio' },
  { value: 'Tecnico', label: 'Técnico' },
  { value: 'Tecnologo', label: 'Tecnólogo' },
  { value: 'Graduacao', label: 'Graduação' },
  { value: 'PosGraduacao', label: 'Pós-graduação' },
  { value: 'Especializacao', label: 'Especialização' },
  { value: 'Mba', label: 'MBA' },
  { value: 'CursoLivre', label: 'Curso livre' },
];

export const EDUCATION_DEGREE_OPTIONS: SelectOption[] = [
  { value: 'EnsinoMedio', label: 'Ensino médio' },
  { value: 'Superior', label: 'Superior' },
  { value: 'PosGraduacao', label: 'Pós-graduação' },
  { value: 'Mestrado', label: 'Mestrado' },
  { value: 'Doutorado', label: 'Doutorado' },
  { value: 'PosDoutorado', label: 'Pós-doutorado' },
];

export const EDUCATION_STATUS_OPTIONS: SelectOption[] = [
  { value: 'Formado', label: 'Formado' },
  { value: 'EmAndamento', label: 'Em andamento' },
  { value: 'Trancado', label: 'Trancado' },
  { value: 'Interrompido', label: 'Interrompido' },
];

export const BRAZILIAN_STATE_OPTIONS: SelectOption[] = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
].map((uf) => ({ value: uf, label: uf }));

export function labelForOption(options: SelectOption[], value?: string | null): string {
  if (!value) return '—';
  return options.find((option) => option.value === value)?.label ?? value;
}
